export const randomElement = <T>(arr: T[]): T => arr[Math.floor(Math.random() * arr.length)];
